/* eslint-disable */
import React, { useEffect } from 'react'
import RouterSetting from 'Router'

import { Provider } from 'react-redux'
import store, { history } from './redux/store'
import { ConnectedRouter } from 'connected-react-router'

import 'antd/dist/antd.css'

import './i18n/i18n'
import { useTranslation } from 'react-i18next';

const App = () => {

const { i18n, t } = useTranslation()

useEffect(()=>{
  if(localStorage.getItem('lang') === null){
    var lang = navigator.language || navigator.userLanguage;
    if(lang ==='zh-TW' || lang ==='zh-CN' || lang === 'zh-HK'){
      lang='tw'
    }else{
      lang='en'
    }
    localStorage.setItem('lang',lang)
  } else {
    localStorage.removeItem('LoginInfo')
    localStorage.removeItem('refresh_token')
    i18n.changeLanguage(localStorage.getItem('lang'))
  }
}, [])
useEffect(()=>{
  const fetchData = async () => {
    // STEP 2：使用 Promise.all 搭配 await 等待兩個 API 都取得回應後才繼續
    // const data = await fetch('https://ipapi.co/json/')
    //   .then(function(response) {
    //     return response.json()
    //   })
    //   .then(function(data) {
    //     return data
    //   })
    // ;
    // if(data){
    //   localStorage.setItem('ip_address',data.ip)
    // }

    
  };

  // STEP 5：呼叫 fetchData 這個方法
  fetchData();
},[])
// useEffect(()=>{
//   if(process.env.REACT_APP_CHAT_URL && process.env.REACT_APP_CHAT_TOKEN){
//   // window.chatwootSettings = {
//   //   type: "expanded_bubble",
//   //   launcherTitle: t('Chat.ChatButton'),
//   //   darkMode: "auto",
//   // };
//   (function(d,a) {
//     var BASE_URL=process.env.REACT_APP_CHAT_URL;
//     var g=d.createElement(a),s=d.getElementsByTagName(a)[0];
//     g.src=BASE_URL+"/packs/js/sdk.js";
//     g.defer = true;
//     g.async = true;
//     s.parentNode.insertBefore(g,s);
//     g.onload=function(){
//       window.chatwootSDK.run({
//         websiteToken: process.env.REACT_APP_CHAT_TOKEN,
//         baseUrl: BASE_URL
//       })
//     }
//   })(document,"script");
//   }
// },[])
// useEffect(()=>{
//   if(window.$chatwoot){
//   window.$chatwoot.locale = i18n.language ==='tw'? 'zh_TW':'en' ;
//   window.$chatwoot.launcherTitle = `${t('Chat.ChatButton')}`; 
//   window.$chatwoot.reset();
//   }
// },[i18n.language])


return(
<>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <RouterSetting {...store}/>
    </ConnectedRouter>
  </Provider>
</>
)
}
export default App
